import { useNavigate } from 'react-router-dom'
import { ArrowRight, Plus, Store } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'
import { routes } from '@/shared/constants'

/**
 * Vacío educativo del onboarding: el usuario sin organización (aún no es
 * cliente) es invitado a crear su primer negocio. Lo usan BusinessesPage
 * (estado `firstTime`) y el `noOrgFallback` de los <OrgRoleGate> de las rutas
 * del portal (goal portal-roles-1).
 */
export function FirstBusinessOnboarding() {
  const navigate = useNavigate()

  return (
    <div className="mx-auto max-w-xl py-10">
      <div className="flex flex-col items-center rounded-card border border-dashed border-line bg-panel p-10 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-soft text-brand">
          <Store className="h-8 w-8" />
        </div>
        <h1 className="mt-6 font-serif text-3xl font-normal tracking-tight text-ink">
          ¡Bienvenido a TecoPOS!
        </h1>
        <p className="mt-2 max-w-sm text-sm text-ink-muted">
          Crea tu primer negocio para empezar. En unos pasos lo dejamos listo con sus
          servicios; tu organización se crea automáticamente en el proceso.
        </p>
        <Button
          variant="primary"
          className="mt-7"
          onClick={() => navigate(routes.app.businesses.new)}
        >
          <Plus className="h-4 w-4" />
          Crear mi negocio
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
